// Maps EspoCRM record URLs to friendly labels shown in the dashboard.
// Order matters: CEventoHuerfano must be checked before Contact.
const ESPOCRM_LABELS = [
  ['CPlanDePagos/view', '📋 Ver Plan de Pagos'],
  ['Opportunity/view', '💼 Ver Oportunidad'],
  ['CEventoHuerfano/view', '🟠 Ver Huérfano'],
  ['Contact/view', '👤 Ver Contacto'],
];

// Returns the masked label when the URL points to a known EspoCRM record
// type, otherwise returns the URL untouched.
export const espoCrmLabel = url => {
  if (!url) return url;
  const match = ESPOCRM_LABELS.find(([fragment]) => url.includes(fragment));
  return match ? match[1] : url;
};
